export default {
  currentUser(state) {
    return state.currentUser;
  },
  testUser(state) {
    return state.testUser;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  didAutoLogout(state) {
    return state.didAutoLogout;
  },
  //root state 접근법  Name(state, getters, rootState, rootGetter){

};
